import React, { useEffect, useState } from 'react';
import { QueryClient, QueryClientProvider } from "react-query";
import { RouterProvider } from "react-router-dom";
import toast, { Toaster } from 'react-hot-toast';
//import { LoginOneSignal, LogoutOneSignal, RunOneSignal } from './utils/OneSignal';
import UserContext from './hooks/UserContext';
import ConfigContext from './hooks/ConfigContext';
import Api from './utils/Api'
import Loading from './components/Loading';
import { ThemeProvider } from 'styled-components';
import router from './routes';
import getTheme from './themes';

export default function App() {
  const [user, setUser] = useState(null);
  const [config, setConfig] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const theme = getTheme();
  const queryClient = new QueryClient({});

  useEffect(() => {

    const getConfig = async () => {
      const [error, config] = await Api.getConfig();
      if (error) throw (error);
      if (config) {
        setConfig(config);
        return config;
      }
    }

    const getUser = async () => {
      const [error, user] = await Api.getCurrentUser();
      if (error) {
        // clear auth token
        await Api.logout();
        setUser(null);
        return null;
      }
      else if (user) {
        setUser(user);
        return user;
      }
    }

    const load = async () => {
      try {
        setIsLoading(true);
        await getConfig();
        await getUser();
        //await RunOneSignal(config);
        setIsLoading(false);
      } catch (error) {
        setIsLoading(false);
        console.error(error);
        return toast.error(Api.error(error))
      }
    }

    load();

  }, []);

  const userContext = {
    user,
    login: async ({ email, password }) => {
      const [err, user] = await Api.login({ email, password });
      if (err) {
        console.error(err);
        //await LogoutOneSignal();
        setUser(null);
        return err;
      } else {
        //await LoginOneSignal(user);
        setUser(user);
        return null;
      }
    },
    proxyAs: async ({ _id: userId }) => {
      const [error, newUser] = await Api.proxyAs(userId);
      if (error) return [error, null];
      //await LoginOneSignal(newUser);
      setUser(newUser);
      return [null, null];
    },
    logout: async () => {
      await Api.logout();
      //await LogoutOneSignal();
      setUser(null);
    },
    updateUser: user => {
      setUser(user);
    }
  }

  return (
    <>
      <Toaster toastOptions={{
        // Define default options
        duration: 2500,
        style: {
          fontSize: '1rem',
          width: '80%',
        }
      }} />
      <ThemeProvider theme={theme}>
        <Loading isLoading={isLoading} >
          <QueryClientProvider client={queryClient}>
            <ConfigContext.Provider value={config}>
              <UserContext.Provider value={userContext}>
                <RouterProvider router={router} />
              </UserContext.Provider>
            </ConfigContext.Provider>
          </QueryClientProvider>
        </Loading>
      </ThemeProvider >
    </>
  );
};